import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { AsideDefault } from '../components/aside/AsideDefault'
import { Footer } from '../components/footer'
import { HeaderWrapper } from '../components/header/HeaderWrapper'
import { ScrollTop } from '../components/scrollTop'
import { Content } from '../components/content'
import { PageDataProvider } from '../core'
import { useLocation } from 'react-router-dom'
import { DrawerMessenger, ActivityDrawer, Main, InviteUsers, UpgradePlan } from '../partials'
import { MenuComponent } from '../theme/components'

const PrivateLayout = () => {
    const location = useLocation()
    useEffect(() => {
        setTimeout(() => {
            MenuComponent.reinitialization()
        }, 500)
    }, [])

    useEffect(() => {
        setTimeout(() => {
            MenuComponent.reinitialization()
        }, 500)
    }, [location.key])

    return (
        <PageDataProvider>
            <div className='page d-flex flex-row flex-column-fluid'>
                <AsideDefault />
                <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
                    <HeaderWrapper />
                    <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
                        <div className='post d-flex flex-column-fluid' id='kt_post'>
                            <Content>
                                <Outlet />
                            </Content>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>

            {/* begin:: Drawers */}
            <ActivityDrawer />
            <DrawerMessenger />
            {/* end:: Drawers */}

            {/* begin:: Modals */}
            <Main />
            <InviteUsers />
            <UpgradePlan />
            {/* end:: Modals */}
            <ScrollTop />
        </PageDataProvider>
    )
}

export default PrivateLayout
